<template>
  <div>
    <div>
      {{ $options.filters.localTime(appointment.start, 'HH:mm')}} - {{ $options.filters.localTime(appointment.end, 'HH:mm')}}
      <span><i v-if="(appointment.started_at === null && appointment.status) || (appointment.status && appointment.ended_at)" class="fa fa-lock"> </i></span>
    </div>
    <div v-if="appointment.person" class="person-name">
      <span v-if="appointment.person.first_name" v-text="appointment.person.first_name"></span>
      <span v-if="appointment.person.last_name" v-text="` ${appointment.person.last_name}`"></span>
    </div>
    <div v-if="appointment.person && appointment.person.phone">
      <span v-text="appointment.person.phone"></span>
    </div>
    <div v-if="appointment.user">
      <span v-if="appointment.user.nickname" v-text="appointment.user.nickname"></span>
      <span v-else v-text="appointment.user.name"></span>
    </div>
    <div v-if="appointment.facility">
      {{appointment.facility.name}} <span v-if="location" v-text="` (${location})`"></span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    appointment: {
      type: Object,
      required: true
    }
  },
  computed: {
    location: function () {
      if (this.appointment.facility.address && this.appointment.facility.address.city) {
        return this.appointment.facility.address.city
      }
      return null
    }
  }
}
</script>
